import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { RichTextEmphasis } from '@features/spots/umbraco-block-list-spot/block-list-spot.models';
import { SafePipe } from '@shared/safe/safe.pipe';
import { InterceptLinksDirective } from '../../../@libs/routing/dynamic-routing/intercept-links.directive';
import { SpotHeadlineComponent } from '../spot-headline/spot-headline.component';
import { NgFor, NgIf } from '@angular/common';

@Component({
    selector: 'app-rich-text-emphasis',
    templateUrl: './rich-text-emphasis.component.html',
    styleUrls: ['./rich-text-emphasis.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [NgFor, NgIf, SpotHeadlineComponent, InterceptLinksDirective, SafePipe]
})
export class RichTextEmphasisComponent {
    public static readonly ref: string = 'richTextEmphasis';

    @Input()
    public data: RichTextEmphasis;
}
